module.exports = __webpack_public_path__ + "media/src/images/Poweredby_100px-White_VertText-60eb01189cc852e4101d9e731bfb9c61.png";